import instance from "../axios/axios.config";
const { provision } = instance;

export const getTFToJsonApi = async (service) => {
    try {
        const response = await provision.get(`/transformer/tf_to_json?service=${service}`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const planTerraformApi = async (payload) => {
    try {
        const response = await provision.post(`/terraform/terraform_plan`, payload)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const updateProvisionApi = async (id, payload) => {
    try {
        const response = await provision.put(`/provisions/${id}`, payload)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getAllServicesApi = async () => {
    try {
        const response = await provision.get(`aws_services`)
        return response?.result?.services || []
    } catch (error) {
        console.error(error)
    }
}

export const cancelTerraformPlanApi = async (payload) => {
    try {
        const response = await provision.delete(`/terraform/terraform_cancel`, { data: payload })
        return response?.result || []
    } catch (error) {
        console.error(error)
    }
}

export const approveAndApplyApi = async (payload) => {
    try {
        const response = await provision.post(`/terraform/terraform_apply`, payload)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getAllProvisionApi = async () => {
    try {
        const response = await provision.get(`/provisions`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const terminatePlanApi = async (payload) => {
    try {
        const response = await provision.delete(`/terraform/terraform-destroy-plan`, { data: payload })
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const terminateDestroyApi = async (payload) => {
    try {
        const response = await provision.delete(`/terraform/terraform-destroy`, { data: payload })
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}
export const getVpcSubnetsApi = async (credName, region) => {
    try {
        const response = await provision.get(`/terraform/vpc-subnets?credName=${credName}&region=${region}`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const deleteProvisionApi = async (id) => {
    try {
        const response = await provision.delete(`/provisions/${id}`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getLogsByProvisionIdApi = async (provisionId) => {
    try {
        const response = await provision.get(`/provisions/${provisionId}/logs`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getAnalyticsByProvisionApi = async (provisionId) => {
    try {
        const response = await provision.get(`/provisions/${provisionId}/cost-sec-details`)
        return response?.result || {}
    } catch (error) {
        console.error('Error fetching provision analytics:', error);
        return {};
    }
}